import * as React from "react";
import { DotsSixVerticalIcon } from "@phosphor-icons/react";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "../../lib/utils";

function ResizablePanelGroup({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
  return (
    <ResizablePrimitive.PanelGroup
      data-slot="resizable-panel-group"
      className={cn(
        "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
        className,
      )}
      {...props}
    />
  );
}

function ResizablePanel({
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.Panel>) {
  return <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;
}

function ResizableHandle({
  withHandle,
  className,
  style,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
}) {
  return (
    <ResizablePrimitive.PanelResizeHandle
      data-slot="resizable-handle"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#e0e0e0",
        zIndex: 10,
        transition: "background-color 0.2s",
        // Default horizontal handle
        cursor: "col-resize",
        width: "4px",
        // These will be overridden by CSS for vertical handles
        ...style,
      }}
      onMouseEnter={(e) => {
        const target = e.currentTarget as unknown as HTMLElement;
        if (target && target.style) {
          target.style.backgroundColor = "#1976d2";
        }
      }}
      onMouseLeave={(e) => {
        const target = e.currentTarget as unknown as HTMLElement;
        if (target && target.style) {
          target.style.backgroundColor = "#e0e0e0";
        }
      }}
      className={cn(
        // CSS for handling vertical vs horizontal orientation
        "resizable-handle",
        "[&[data-panel-group-direction=vertical]]:cursor-row-resize",
        "[&[data-panel-group-direction=vertical]]:h-1",
        "[&[data-panel-group-direction=vertical]]:w-full",
        className,
      )}
      {...props}
    >
      {withHandle && (
        <div
          style={{
            backgroundColor: "#e0e0e0",
            zIndex: 10,
            display: "flex",
            height: "16px",
            width: "12px",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "2px",
            border: "1px solid #ccc",
          }}
        >
          <DotsSixVerticalIcon style={{ width: "10px", height: "10px" }} />
        </div>
      )}
    </ResizablePrimitive.PanelResizeHandle>
  );
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
